import type { GenerationErrorCode } from "@skilitics/nautilus-endpoint-definition";

type Details = {
  code: GenerationErrorCode;
  message: string;
  status?: number;
};

export class GenerationError extends Error {
  name = "GenerationError";
  details: Details;

  constructor(details: Details) {
    super(details.message);
    this.details = { ...details, status: details.status ?? 400 };
  }
}
